import React from 'react';
import s from './s.module.less';
import Icon from './icon.png';
import { Button } from 'antd';
import AuthButton from '../AuthButton';

type Props = {
    onClickDismiss?: () => void;
    successCallbackPath?: string;
    actionBtn?: React.ReactElement;
};

const AuthBanner = (props: Props) => {
    const { successCallbackPath, actionBtn } = props;
    return (
        <div className={s.wrap}>
            <div className={s.left}>
                <img src={Icon} width={50} height={50} />
                <div className={s.info}>
                    <div className={s.title}>Connect your Google Calendar for seamless appointment syncing</div>
                    <div className={s.des}>
                        Link your Google Calendar account to sync appointments between Klarity Health and your EHR,
                        ensuring all your appointments are in one place and prevent double bookings.
                    </div>
                </div>
            </div>
            <div className={s.right}>
                {actionBtn || (
                    <Button onClick={props?.onClickDismiss} className={s.btnLight}>
                        Dismiss
                    </Button>
                )}
                <AuthButton successCallbackPath={successCallbackPath} type="primary" />
            </div>
        </div>
    );
};

export default AuthBanner;
